module.exports = __webpack_public_path__ + "static/media/techAsia.bc7fb9c7.png";